import { createSlice } from "@reduxjs/toolkit";
import { PssStoreSlices } from "../../../configs/_pss.store.slice";

export interface PssLayoutStoreSlice {
  sidebarShow: boolean;
  sidebarUnfoldable: boolean;
  asideShow: boolean;
  theme: string;
}

const initialState: PssLayoutStoreSlice = {
  sidebarShow: true,
  sidebarUnfoldable: false,
  asideShow: false,
  theme: "light",
};

const pssLayoutSlice = createSlice({
  name: "pssLayout",
  initialState,
  reducers: {
    storePssSetLayout: (state, { payload }) => {
      return { ...state, ...payload };
    },
  },
});

// Actions / Reducers
export const { storePssSetLayout: storePssSetLayout } = pssLayoutSlice.actions;

// Selectors
export const storePssSelectLayout = (state: PssStoreSlices) => state.pssLayout;

export const storePssSelectSidebarShow = (state: PssStoreSlices) =>
  state.pssLayout.sidebarShow;

export const storePssSelectSidebarUnfoldable = (state: PssStoreSlices) =>
  state.pssLayout.sidebarUnfoldable;

export const storePssSelectAsideShow = (state: PssStoreSlices) =>
  state.pssLayout.asideShow;

export const storePssSelectTheme = (state: PssStoreSlices) =>
  state.pssLayout.theme;

// Reducer
export default pssLayoutSlice.reducer;
